var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.revenueBeta)?_c('receivables-analysis'):_c('receivables-legacy')}
var staticRenderFns = []

export { render, staticRenderFns }